import { CbhIcon, Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";
import { DeprecatedGlobalAppV1Paths } from "@src/appV2/App/paths";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { generatePath, useHistory } from "react-router-dom";

import { Button } from "../../components/Button";

interface AccessLockedButtonProps {
  lockedByWorkplaceId: string;
}

export function AccessLockedButton(props: AccessLockedButtonProps) {
  const { lockedByWorkplaceId } = props;
  const history = useHistory();

  return (
    <Button
      variant="contained"
      size="large"
      sx={(theme) => ({
        minWidth: "30%",
        backgroundColor: theme.palette.intent?.neutral.icon,
        "&:hover": {
          backgroundColor: theme.palette.intent?.neutral.icon,
        },
      })}
      onClick={() => {
        logEvent(APP_V2_USER_EVENTS.VISIT_LOCK_ACCESS_LOCKED_TAPPED, {
          lockedByWorkplaceId,
        });
        history.push(
          generatePath(DeprecatedGlobalAppV1Paths.CHAT, {
            facilityId: lockedByWorkplaceId,
          })
        );
      }}
    >
      <Stack direction="row" spacing={2} alignItems="center">
        <CbhIcon type="locked" size="small" />
        <Text sx={{ color: "white" }}>Access Locked</Text>
      </Stack>
    </Button>
  );
}
